/**
 * Minimal CSV helpers shared by admin exports.
 *
 * `toCsv` quotes only what needs quoting (commas, quotes, newlines) and
 * doubles embedded quotes, per RFC 4180. `downloadCsv` hands the text to
 * the browser as a file; it is a no-op outside a DOM (tests).
 */

import { triggerBlobDownload } from './triggerDownload';

export function csvEscape(value: string | number | null | undefined): string {
  const text = value === null || value === undefined ? '' : String(value);
  if (text.includes(',') || text.includes('"') || text.includes('\n')) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function toCsv(header: string[], rows: (string | number | null | undefined)[][]): string {
  return [header, ...rows].map((r) => r.map(csvEscape).join(',')).join('\n');
}

export function downloadCsv(filename: string, csv: string): void {
  if (typeof document === 'undefined' || typeof URL.createObjectURL !== 'function') return;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  triggerBlobDownload(url, filename);
  URL.revokeObjectURL(url);
}
